module.exports = __webpack_public_path__ + "media/images/icons/small_area_icon-bb06fee1474f6884280b213f877a72c7.png";